import { render, staticRenderFns } from "./chanceList.vue?vue&type=template&id=40b09221&scoped=true&"
import script from "./chanceList.vue?vue&type=script&lang=js&"
export * from "./chanceList.vue?vue&type=script&lang=js&"
import style0 from "./chanceList.vue?vue&type=style&index=0&id=40b09221&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b09221",
  null
  
)

export default component.exports